import React, { useEffect, useState } from 'react';
import { Button, Tag, message } from 'antd';
import { IoIosArrowForward } from 'react-icons/io';
import { useGlobalState } from '../../../store/state';

const { CheckableTag } = Tag;
const ProfileUserInterestsComponent = ({ setCurrentTab, updateProfile, interests }) => {
  const [user] = useGlobalState('user');
  const [opted, setOpted]= useState([]);
  const handleCheck = (topic, checked) =>{
    const nextSelectedTags = checked ? [...opted, topic] : opted.filter((t) => t !== topic);
    setOpted([...nextSelectedTags]);

    console.log('opted', opted);
  };

  useEffect(()=>{
    setOpted([...user.interests]);
  }, [interests, user]);

  const saveInterests = () => {
    console.log('opted', opted);
    const _data = {
      // interests:[]
      interests: opted,
    };
    // @note sent data to update in profile
    updateProfile(_data);
    // if(!opted.length){
    // message.warning('Please select some Interested area')
    // }
  };
  return (
    <div className="prof_widget_platforms">
      <div className="row">
        <div className="col-12">
          <h4>Choose your Interests</h4>
          <p className="m-0">Flynt is an all inclusive interest community that connects like-minded people</p>
        </div>
        <div className="col-12 pt-2">
          <div className="prof_widget_interests">
            {
              interests.map((topic) =>(
                <CheckableTag
                  className="prof_widget_interests_tag"
                  key={topic}
                  checked={opted.indexOf(topic.toLowerCase()) > -1}
                  onChange={(checked) => handleCheck(topic.toLowerCase(), checked)}
                >
                  {topic}
                </CheckableTag>
              ))
            }
          </div>
        </div>
        <div className="col-md-12 text-right pt-2">
          <span>
            <Button htmlType="submit"
              className="common_button outlined"
              onClick={saveInterests}>Save</Button>
          </span>
          <span className="ml-3">
            <Button className="common_button outlined"
              onClick={() => setCurrentTab('3')}>Wallet <IoIosArrowForward className="ml-2"/></Button>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProfileUserInterestsComponent;
